import { useOrganizationSettingsQuery } from '@shared/generated/graphql';
import { OrganizationSettings } from '@shared/types/organization';

type UseOrganizationSettingsOptions = {
  id: string;
  pollIntervalMs?: number;
  skip?: boolean;
};

type UseOrganizationSettingsState = {
  settings?: OrganizationSettings;
  isLoading: boolean;
};

type UseOrganizationSettingsActions = {
  // add any actions the hook provides
};

export type UseOrganizationSettingsValue = UseOrganizationSettingsState &
  UseOrganizationSettingsActions;

const useOrganizationSettings = (
  props: UseOrganizationSettingsOptions
): UseOrganizationSettingsValue => {
  const { id } = props;
  const { data, loading } = useOrganizationSettingsQuery({
    variables: {
      id,
    },
    skip: props.skip,
    ...(props?.pollIntervalMs && { pollInterval: props.pollIntervalMs }),
  });

  const settingsData = data?.organizationById?.settings;

  return {
    settings: settingsData ? (settingsData as OrganizationSettings) : undefined,
    isLoading: loading,
  };
};

export default useOrganizationSettings;
